import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Alert,
  CircularProgress,
  Paper,
  IconButton,
  Chip,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Card,
  CardContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
  Grid,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Drawer,
  useMediaQuery,
  useTheme,
  AppBar,
  Toolbar,
  Fab,
  Collapse,
  ExpandMoreIcon,
  ExpandLessIcon,
  Layout,
  MobileStepper,
  BottomNavigation,
  BottomNavigationAction,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Breadcrumbs,
  Link,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import MenuIcon from '@mui/icons-material/Menu';
import GroupIcon from '@mui/icons-material/Group';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ListIcon from '@mui/icons-material/List';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import apiClient from '../api/apiClient';
import progressService from '../services/progressService';
import InfoIcon from '@mui/icons-material/Info';

const SubscriptionForm = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [approvedEmail, setApprovedEmail] = useState('');
  const [applicantName, setApplicantName] = useState('');
  const [organizationName, setOrganizationName] = useState('');
  const [entityType, setEntityType] = useState('');
  const [investmentType, setInvestmentType] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [currentSection, setCurrentSection] = useState('overview');
  const [activeStep, setActiveStep] = useState(0);
  
  // Responsive navigation state
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  
  // Form data state
  const [formData, setFormData] = useState({
    // Investor Profile - Personal/Entity Details
    investorName: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    socialSecurityNumber: '',
    legalResidentState: '',
    overAge18: '',
    
    // Contact Information
    primaryPhone: '',
    primaryEmail: '',
    residenceAddress: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'United States',
    
    // Mailing Address
    mailingAddressSame: 'yes',
    mailingAttention: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZipCode: '',
    mailingCountry: 'United States',
    
    // Wire Instructions for Distributions
    bankName: '',
    bankAddress: '',
    routingNumber: '',
    accountName: '',
    accountNumber: '',
    
    // AML Information
    wiringBankName: '',
    isWiringBankFATF: '',
    isInvestorCustomerOfBank: '',
    sourceOfWealth: '',
    
    // Tax Information
    taxExemptFromUSFederalIncomeTax: '',
    isGrantorTrustOrDisregardedEntity: '',
    
    // General Eligibility - General Representations
    wasReferredByPlacementAgent: '',
    isGovernmentEntity: '',
    isActingAsAgentForBeneficialOwner: '',
    isIndividualInvestingOver1Million: '',
    
    // Accredited Investor Verification
    accreditedInvestorStatus: '',
    individualNetWorthOver1Million: false,
    naturalPersonQualifiedInstitutionalBuyer: false,
    
    // Electronic Communications Consent
    consentToElectronicDelivery: '',
    
    // Authorized Representatives
    hasAuthorizedRepresentative: '',
    authorizedSignatoryName: '',
    authorizedSignatoryTitle: '',
    authorizedSignatoryEmail: '',
    authorizedSignatoryPhone: '',
    hasAdditionalRepresentatives: '',
    
    // Basic Questions
    howDidYouHear: '',
    isTransferRelated: '',
    investmentPurpose: '', // individual, investment team, advisor
    purposeOfAccount: '',
    isPoliticallyExposed: '',
    politicalExposureDetails: '',
    hasConvictions: '',
    convictionDetails: '',
    isSanctioned: '',
    sanctionDetails: '',
    
    // Tax Information
    exemptFromUSTax: '',
    isGrantorTrust: '',
    selectedTaxDocument: '',
    taxResidency: '',
    foreignTaxIdNumber: '',
    treatyBenefits: '',
    withholdingExemption: '',
    
    // W-9 Form Fields (US Persons)
    w9EntityName: '',
    w9BusinessName: '',
    w9FederalTaxClassification: '',
    w9LlcClassification: '',
    w9OwnershipInterest: '',
    w9LegalAddress: '',
    w9City: '',
    w9State: '',
    w9ZipCode: '',
    w9Country: 'United States',
    w9AccountNumbers: '',
    w9TinNumber: '',
    w9TinType: 'ssn',
    w9BackupWithholding: '',
    w9Certification: '',
    
    // W-8 Form Fields (Foreign Persons)
    w8EntityName: '',
    w8CountryOfIncorporation: '',
    w8TaxpayerIdNumber: '',
    w8ForeignTaxIdType: '',
    w8ResidenceCountry: '',
    w8PermanentAddress: '',
    w8MailingAddress: '',
    w8TreatyCountry: '',
    w8TreatyArticle: '',
    w8WithholdingRate: '',
    w8Certification: '',
    
    // General Eligibility
    referredByPlacementAgent: '',
    placementAgentName: '',
    placementAgentFirm: '',
    placementAgentCompensation: '',
    isGovernmentEntity: '',
    governmentEntityType: '',
    isRegisteredInvestmentCompany: '',
    investmentCompanyType: '',
    numberOfBeneficialOwners: '',
    isBenefitPlanInvestor: '',
    benefitPlanType: '',
    planAssets: '',
    isERISA: '',
    fiduciaryDetails: '',
    
    // Accredited Investor Verification
    accreditedInvestorStatus: '',
    accreditedInvestorType: '',
    investmentAmount: '',
    minimumInvestment: '',
    maximumInvestment: '',
    professionalLicenseType: '',
    accreditedVerificationMethod: '',
    netWorthCertification: '',
    incomeCertification: '',
    professionalKnowledgeCertification: '',
    entityAssetsCertification: '',
    
    // Electronic Communications
    electronicConsent: '',
    electronicDelivery: '',
    emailUpdates: '',
    smsNotifications: '',
    
    // Additional Information
    hasInvestmentAdvisor: '',
    investmentAdvisorName: '',
    investmentAdvisorFirm: '',
    investmentAdvisorContact: '',
    hasThirdPartyAccess: '',
    thirdPartyName: '',
    thirdPartyRelationship: '',
    thirdPartyPermissions: '',
    specialInstructions: '',
    additionalComments: '',
  });

  // Add state to track if user has completed submission
  const [isSubmissionCompleted, setIsSubmissionCompleted] = useState(false);
  const [submissionDate, setSubmissionDate] = useState(null);

  // File upload states
  const [uploadedFiles, setUploadedFiles] = useState({
    amlIdDocuments: [],
    amlAddressDocuments: [],
    taxDocuments: [],
    accreditedDocuments: [],
    individualIdDocuments: [],
    proofOfAddressDocuments: [],
    // Individual ID documents
    license_front: [],
    license_back: [],
    alternative_id: [],
    // Entity authorized signatory documents
    authorized_signatory_docs: [],
    additional_representatives: [],
  });

  const sections = [
    {
      id: 'overview',
      title: 'Overview',
      icon: <DescriptionIcon />,
      description: 'Review your application progress'
    },
    {
      id: 'basic-questions',
      title: 'Basic Information',
      icon: <InfoIcon />,
      description: 'Basic questions and account purpose'
    },
    {
      id: 'investor-profile',
      title: 'Investor Profile',
      icon: <PersonIcon />,
      description: 'Personal/entity details and contact information'
    },
    {
      id: 'aml-information',
      title: 'Anti Money Laundering Information',
      icon: <VerifiedUserIcon />,
      description: 'Identity verification and AML compliance'
    },
    {
      id: 'tax-information',
      title: 'Tax Information',
      icon: <BusinessIcon />,
      description: 'Tax documentation and forms'
    },
    {
      id: 'general-eligibility',
      title: 'General Eligibility',
      icon: <CheckCircleIcon />,
      description: 'Investment eligibility and representations'
    },
    {
      id: 'accredited-investor-verification',
      title: 'Accredited Investor Verification',
      icon: <VerifiedUserIcon />,
      description: 'Accredited investor status verification'
    },
    {
      id: 'wire-instructions',
      title: 'Wire Instructions for Distributions',
      icon: <AccountBalanceIcon />,
      description: 'Banking information for distributions'
    },
    {
      id: 'electronic-communications',
      title: 'Electronic Communications Consent',
      icon: <EmailIcon />,
      description: 'Communication preferences and consent'
    },
    {
      id: 'authorized-representatives',
      title: entityType === 'individual' ? 'Document Upload' : 'Authorized Representatives',
      icon: <BusinessIcon />,
      description: entityType === 'individual' ? 'Upload ID and proof of identification' : 'Authorized signatories and representatives'
    }
  ];

  const [stepIndex, setStepIndex] = useState(0);
  const sectionOrder = [
    'entity-selection',
    'basic-information',
    'investor-profile',
    'aml-information', 
    'tax-information',
    'general-eligibility',
    'accredited-investor-verification',
    'wire-instructions',
    'electronic-communications',
    'authorized-representatives',
    'submit'
  ];

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const email = localStorage.getItem('approved-email');
        const token = localStorage.getItem('registration-token');
        
        if (!email || !token) {
          navigate('/');
          return;
        }
        
        setApprovedEmail(email);
        
        // Load user progress from progress service
        const progress = await progressService.getCurrentProgress(email);
        
        // Check if user has completed submission
        if (progress.registration_step === 'subscription_submitted' || 
            progress.subscription_status === 'submitted') {
          console.log('✅ SubscriptionForm: User has completed submission');
          setIsSubmissionCompleted(true);
          setSubmissionDate(progress.updated_at || progress.created_at);
          setLoading(false);
          return;
        }
        
        // Set user details with proper defaults
        const applicantNameFromStorage = localStorage.getItem('applicant-name') || '';
        const investmentTypeFromStorage = localStorage.getItem('investment-type') || '';
        const organizationNameFromStorage = localStorage.getItem('organization-name') || '';
        const entityTypeFromStorage = localStorage.getItem('entity-type') || '';
        
        setApplicantName(applicantNameFromStorage);
        setInvestmentType(investmentTypeFromStorage);
        
        if (progress.form_data) {
          const data = progress.form_data;
          
          // Set user details from progress data
          setApplicantName(data.applicant_name || applicantNameFromStorage);
          setInvestmentType(data.investment_type || investmentTypeFromStorage);
          setOrganizationName(data.organization_name || organizationNameFromStorage);
          setEntityType(data.entity_type || entityTypeFromStorage);
          
          // For individual investors, set defaults
          if (data.investment_type === 'individual') {
            const finalOrgName = data.organization_name || data.applicant_name || applicantNameFromStorage || 'Individual Investor';
            const finalEntityType = data.entity_type || 'individual';
            
            setOrganizationName(finalOrgName);
            setEntityType(finalEntityType);
          }
          
          // Load subscription form data if available
          if (data.subscription_data) {
            console.log('📋 SubscriptionForm: Loading saved subscription data:', Object.keys(data.subscription_data));
            setFormData(prev => ({
              ...prev,
              ...data.subscription_data
            }));
          }
          
          // Also check for any other form data stored in progress data
          if (data && typeof data === 'object') {
            const formFields = Object.keys(formData);
            const savedFormData = {};
            
            formFields.forEach(field => {
              if (data[field] !== undefined && data[field] !== null && data[field] !== '') {
                savedFormData[field] = data[field];
              }
            });
            
            if (Object.keys(savedFormData).length > 0) {
              console.log('📋 SubscriptionForm: Loading additional form data:', Object.keys(savedFormData));
              setFormData(prev => ({
                ...prev,
                ...savedFormData
              }));
            }
          }
          
          // Restore uploaded files if available
          if (data.uploaded_files) {
            setUploadedFiles(prev => ({
              ...prev,
              ...data.uploaded_files
            }));
          }
          
          // Restore step progress
          if (data.current_step !== undefined) {
            console.log('🔄 SubscriptionForm: Restoring step position:', data.current_step);
            setStepIndex(data.current_step + 1); // +1 because stepIndex 0 is entity selection
          } else {
            console.log('🔄 SubscriptionForm: No saved step position, starting from beginning');
            setStepIndex(1); // Start from first form section (after entity selection)
          }
        } else {
          // No progress data, set defaults for individual investors
          if (investmentTypeFromStorage === 'individual') {
            setOrganizationName(applicantNameFromStorage || 'Individual Investor');
            setEntityType('individual');
            // If user already selected individual, start from first form section
            setStepIndex(1);
          } else {
            setOrganizationName(organizationNameFromStorage || '');
            setEntityType(entityTypeFromStorage || '');
            // If no selection made, start from entity selection
            setStepIndex(0);
          }
        }
        
        console.log('✅ SubscriptionForm: Data loaded successfully');
      } catch (error) {
        console.error('❌ Error loading subscription data:', error);
        setError('Failed to load subscription data. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    
    loadInitialData();
  }, [navigate]);

  const handleFormDataChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Auto-save form data after a short delay
    clearTimeout(window.autoSaveTimeout);
    window.autoSaveTimeout = setTimeout(() => {
      saveFormData();
    }, 2000); // Save after 2 seconds of inactivity
  };

  const handleFileUpload = (category, files) => {
    const newFiles = Array.from(files).map(file => {
      const fileId = Date.now() + Math.random();
      
      // Convert file to base64
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Data = e.target.result;
        console.log('📁 File converted to base64:', {
          category,
          fileName: file.name,
          fileSize: file.size,
          base64Length: base64Data.length,
          hasData: base64Data.length > 0
        });
        
        // Update the file with base64 data
        setUploadedFiles(prev => ({
          ...prev,
          [category]: prev[category].map(f => 
            f.id === fileId 
              ? { ...f, file: [base64Data], uploaded: false }
              : f
          )
        }));
      };
      reader.readAsDataURL(file);
      
      return {
        id: fileId,
        file: [], // Will be populated with base64 data
        name: file.name,
        size: file.size,
        type: file.type,
        uploaded: false
      };
    });
    
    setUploadedFiles(prev => ({
      ...prev,
      [category]: [...(prev[category] || []), ...newFiles]
    }));
  };

  const removeFile = (category, fileId) => {
    setUploadedFiles(prev => ({
      ...prev,
      [category]: prev[category].filter(file => file.id !== fileId)
    }));
  };

  const calculateProgress = () => {
    const totalFields = Object.keys(formData).length;
    const completedFields = Object.values(formData).filter(value => value && value !== '').length;
    return Math.round((completedFields / totalFields) * 100);
  };

  const calculateSectionProgress = () => {
    // Calculate progress for each section
    const sectionProgress = [];
    
    // Define sections and their fields
    const sectionFields = {
      'investor-profile': [
        'investorName', 'firstName', 'lastName', 'dateOfBirth', 
        'primaryPhone', 'primaryEmail', 'residenceAddress', 'city', 'state', 'zipCode'
      ],
      'aml-information': [
        'wiringBankName', 'isWiringBankFATF', 'isInvestorCustomerOfBank', 'sourceOfWealth'
      ],
      'tax-information': [
        'taxExemptFromUSFederalIncomeTax', 'isGrantorTrustOrDisregardedEntity', 
        'selectedTaxDocument', 'w9EntityName', 'w9TinNumber'
      ],
      'general-eligibility': [
        'wasReferredByPlacementAgent', 'isGovernmentEntity', 'isActingAsAgentForBeneficialOwner'
      ],
      'accredited-investor-verification': [
        'accreditedInvestorStatus', 'individualNetWorthOver1Million'
      ],
      'wire-instructions': [
        'bankName', 'bankAddress', 'routingNumber', 'accountName', 'accountNumber'
      ],
      'electronic-communications': [
        'consentToElectronicDelivery'
      ],
      'authorized-representatives': entityType === 'individual' 
        ? ['hasAuthorizedRepresentative'] // For individuals, just tracking if they have documents uploaded
        : ['authorizedSignatoryName', 'authorizedSignatoryTitle', 'authorizedSignatoryEmail', 'hasAdditionalRepresentatives'],
      'basic-questions': [
        'howDidYouHear', 'isTransferRelated', 'investmentPurpose'
      ]
    };

    // Calculate progress for each section and add to array
    Object.keys(sectionFields).forEach(sectionId => {
      const fields = sectionFields[sectionId];
      const completedFields = fields.filter(field => formData[field] && formData[field] !== '').length;
      const percentage = fields.length > 0 ? Math.round((completedFields / fields.length) * 100) : 0;
      
      sectionProgress.push({
        section: sectionId,
        completed: completedFields,
        total: fields.length,
        percentage: percentage
      });
    });

    return sectionProgress;
  };

  const saveFormData = async () => {
    setLoading(true);
    setError('');
    
    try {
      // Ensure we have the required fields
      const finalOrganizationName = organizationName || applicantName || 'Individual Investor';
      const finalEntityType = entityType || 'individual';
      
      const dataToSave = {
        email: approvedEmail,
        organization_name: finalOrganizationName,
        entity_type: finalEntityType,
        form_data: {
          ...formData,
          uploaded_files: uploadedFiles,
          applicant_name: applicantName,
          investment_type: investmentType,
          organization_name: finalOrganizationName,
          entity_type: finalEntityType
        },
        progress: calculateSectionProgress(),
        last_updated: new Date().toISOString()
      };
      
      console.log('📤 Saving form data:', dataToSave);
      console.log('📁 Uploaded files structure:', {
        uploadedFiles,
        hasFiles: Object.values(uploadedFiles).some(files => files && files.length > 0),
        fileCategories: Object.keys(uploadedFiles).filter(cat => uploadedFiles[cat] && uploadedFiles[cat].length > 0)
      });
      
      // Use apiClient directly to match the expected API format
      const response = await apiClient.post('/investor/save-subscription', dataToSave);
      
      if (response.data.status === 'success') {
        console.log('✅ Subscription progress saved successfully');
        return true;
      } else {
        throw new Error(response.data.message || 'Failed to save progress');
      }
    } catch (error) {
      console.error('❌ Error saving form data:', error);
      setError(error.response?.data?.message || 'Failed to save form data. Please try again.');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const saveCurrentStepAndContinue = async () => {
    setSubmitting(true);
    setError('');
    
    try {
      const currentStep = stepIndex - 1;
      const sections = [
        'basic-questions',
        'investor-profile', 
        'aml-information',
        'tax-information',
        'general-eligibility',
        'accredited-investor-verification',
        'wire-instructions',
        'electronic-communications',
        'authorized-representatives',
        'submit'
      ];
      
      const currentSectionId = sections[currentStep] || 'basic-questions';
      
      // Ensure we have the required fields
      const finalOrganizationName = organizationName || applicantName || 'Individual Investor';
      const finalEntityType = entityType || 'individual';
      
      const dataToSave = {
        email: approvedEmail,
        organization_name: finalOrganizationName,
        entity_type: finalEntityType,
        current_step: currentStep,
        current_section: currentSectionId,
        form_data: {
          ...formData,
          uploaded_files: uploadedFiles,
          applicant_name: applicantName,
          investment_type: investmentType,
          organization_name: finalOrganizationName,
          entity_type: finalEntityType
        },
        progress: calculateSectionProgress(),
        last_updated: new Date().toISOString()
      };
      
      console.log('📤 Saving step data:', dataToSave);
      
      const response = await apiClient.post('/investor/save-subscription', dataToSave);
      
      if (response.data.status === 'success') {
        console.log('✅ Step saved successfully, proceeding to next step');
        
        // Save current step position for cross-device sync
        await progressService.saveCurrentStep(approvedEmail, stepIndex + 1, sectionOrder[stepIndex + 1]);
        
        setStepIndex(stepIndex + 1);
      } else {
        throw new Error(response.data.message || 'Failed to save step');
      }
    } catch (error) {
      console.error('❌ Error saving step:', error);
      setError(error.response?.data?.message || 'Failed to save step. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const renderOverview = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Subscription Application Progress
        </Typography>
        
        <Box sx={{ mb: { xs: 2, md: 3 } }}>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            gutterBottom
            sx={{ fontSize: { xs: '0.875rem', md: '0.875rem' } }}
          >
            Overall Progress: {calculateProgress()}%
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={calculateProgress()} 
            sx={{ 
              height: { xs: 6, md: 8 }, 
              borderRadius: 4 
            }}
          />
        </Box>

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} lg={6}>
            <Typography 
              variant="h6" 
              gutterBottom
              sx={{ fontSize: { xs: '1.125rem', md: '1.25rem' } }}
            >
              Investor Information
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: { xs: 0.5, md: 1 } 
            }}>
              <Typography sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>
                <strong>Name:</strong> {applicantName}
              </Typography>
              <Typography sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>
                <strong>Email:</strong> {isMobile ? approvedEmail.substring(0, 20) + '...' : approvedEmail}
              </Typography>
              <Typography sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>
                <strong>Organization:</strong> {organizationName}
              </Typography>
              <Typography sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>
                <strong>Entity Type:</strong> {entityType}
              </Typography>
              <Typography sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}>
                <strong>Investment Type:</strong> {investmentType}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Typography 
              variant="h6" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1.125rem', md: '1.25rem' },
                mt: { xs: 2, lg: 0 }
              }}
            >
              Section Status
            </Typography>
            <List dense sx={{ p: 0 }}>
              {sections.slice(1).map((section) => (
                <ListItem 
                  key={section.id}
                  button
                  onClick={() => setCurrentSection(section.id)}
                  sx={{ 
                    px: 0,
                    py: { xs: 0.5, md: 1 },
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                >
                  <ListItemIcon sx={{ 
                    minWidth: { xs: 32, md: 40 }
                  }}>
                    {section.icon}
                  </ListItemIcon>
                  <ListItemText 
                    primary={section.title}
                    secondary={!isMobile ? section.description : undefined}
                    primaryTypographyProps={{
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }}
                    secondaryTypographyProps={{
                      fontSize: { xs: '0.75rem', md: '0.875rem' }
                    }}
                  />
                  <Chip 
                    label="Pending" 
                    size={isMobile ? "small" : "small"}
                    color="default"
                    sx={{ 
                      fontSize: { xs: '0.65rem', md: '0.75rem' },
                      height: { xs: 20, md: 24 }
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderInvestorProfile = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Investor Profile
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          0/21 complete
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Investor Name - Adapt based on entity type */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={
                entityType === 'individual' 
                  ? "Full Legal Name (as appears on government documents)"
                  : "Entity/Organization Name"
              }
              value={formData.investorName}
              onChange={(e) => handleFormDataChange('investorName', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {/* Individual-specific fields */}
          {entityType === 'individual' && (
            <>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="First Name"
                  value={formData.firstName}
                  onChange={(e) => handleFormDataChange('firstName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Middle Name"
                  value={formData.middleName}
                  onChange={(e) => handleFormDataChange('middleName', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Last Name"
                  value={formData.lastName}
                  onChange={(e) => handleFormDataChange('lastName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Date of Birth"
                  type="date"
                  value={formData.dateOfBirth}
                  onChange={(e) => handleFormDataChange('dateOfBirth', e.target.value)}
                  required
                  InputLabelProps={{ shrink: true }}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
          
          {/* Contact Information */}
          <Grid item xs={12}>
            <Typography 
              variant="h6" 
              gutterBottom 
              sx={{ 
                mt: { xs: 2, md: 3 },
                fontSize: { xs: '1.125rem', md: '1.25rem' }
              }}
            >
              Contact Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Primary Phone Number"
              value={formData.primaryPhone}
              onChange={(e) => handleFormDataChange('primaryPhone', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Primary Email"
              type="email"
              value={formData.primaryEmail}
              onChange={(e) => handleFormDataChange('primaryEmail', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {/* Address Information */}
          <Grid item xs={12}>
            <Typography 
              variant="h6" 
              gutterBottom 
              sx={{ 
                mt: { xs: 2, md: 3 },
                fontSize: { xs: '1.125rem', md: '1.25rem' }
              }}
            >
              {entityType === 'individual' ? 'Residence Address' : 'Primary Address'}
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Street Address"
              value={formData.residenceAddress}
              onChange={(e) => handleFormDataChange('residenceAddress', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="City"
              value={formData.city}
              onChange={(e) => handleFormDataChange('city', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              label="State"
              value={formData.state}
              onChange={(e) => handleFormDataChange('state', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              label="Zip Code"
              value={formData.zipCode}
              onChange={(e) => handleFormDataChange('zipCode', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Country</InputLabel>
              <Select
                value={formData.country}
                onChange={(e) => handleFormDataChange('country', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="United States">United States</MenuItem>
                <MenuItem value="Canada">Canada</MenuItem>
                <MenuItem value="United Kingdom">United Kingdom</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Mailing Address Section */}
          <Grid item xs={12}>
            <Typography 
              variant="h6" 
              gutterBottom 
              sx={{ 
                mt: { xs: 2, md: 3 },
                fontSize: { xs: '1.125rem', md: '1.25rem' }
              }}
            >
              Mailing Address
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Is your Mailing Address the same as your {entityType === 'individual' ? 'Residence' : 'Primary'} Address?
            </Typography>
            <RadioGroup
              value={formData.mailingAddressSame}
              onChange={(e) => handleFormDataChange('mailingAddressSame', e.target.value)}
              row
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </Grid>
          
          {formData.mailingAddressSame === 'no' && (
            <>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Attention (Optional)"
                  value={formData.mailingAttention}
                  onChange={(e) => handleFormDataChange('mailingAttention', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Mailing Street Address"
                  value={formData.mailingAddress}
                  onChange={(e) => handleFormDataChange('mailingAddress', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Mailing City"
                  value={formData.mailingCity}
                  onChange={(e) => handleFormDataChange('mailingCity', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Mailing State"
                  value={formData.mailingState}
                  onChange={(e) => handleFormDataChange('mailingState', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Mailing Zip Code"
                  value={formData.mailingZipCode}
                  onChange={(e) => handleFormDataChange('mailingZipCode', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
  
  // New render functions for missing sections
  const renderBasicQuestions = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
          Basic Information
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please provide basic information about your investment and how you heard about us.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Investment Purpose */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
              Investment Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>How did you hear about us?</InputLabel>
              <Select
                value={formData.howDidYouHear}
                onChange={(e) => handleFormDataChange('howDidYouHear', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="referral">Referral</MenuItem>
                <MenuItem value="website">Website</MenuItem>
                <MenuItem value="social-media">Social Media</MenuItem>
                <MenuItem value="advertisement">Advertisement</MenuItem>
                <MenuItem value="financial-advisor">Financial Advisor</MenuItem>
                <MenuItem value="search-engine">Search Engine</MenuItem>
                <MenuItem value="email-marketing">Email Marketing</MenuItem>
                <MenuItem value="conference-event">Conference/Event</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Is this subscription document related to a transfer?</InputLabel>
              <Select
                value={formData.isTransferRelated}
                onChange={(e) => handleFormDataChange('isTransferRelated', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
                <MenuItem value="not-sure">Not Sure</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Purpose of Account"
              value={formData.purposeOfAccount}
              onChange={(e) => handleFormDataChange('purposeOfAccount', e.target.value)}
              multiline
              rows={3}
              helperText="Please describe the purpose of this investment account (e.g., retirement planning, wealth preservation, growth, etc.)"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {/* Personal Information for Individual Investors */}
          {entityType === 'individual' && (
            <>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
                  Personal Information
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Full Legal Name"
                  value={formData.investorName}
                  onChange={(e) => handleFormDataChange('investorName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Date of Birth"
                  type="date"
                  value={formData.dateOfBirth}
                  onChange={(e) => handleFormDataChange('dateOfBirth', e.target.value)}
                  required
                  InputLabelProps={{ shrink: true }}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Social Security Number"
                  value={formData.socialSecurityNumber}
                  onChange={(e) => handleFormDataChange('socialSecurityNumber', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Legal Resident State"
                  value={formData.legalResidentState}
                  onChange={(e) => handleFormDataChange('legalResidentState', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                    Are you over 18 years of age? *
                  </Typography>
                  <RadioGroup
                    value={formData.overAge18}
                    onChange={(e) => handleFormDataChange('overAge18', e.target.value)}
                    row={!isMobile}
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: { xs: '0.875rem', md: '1rem' }
                      }
                    }}
                  >
                    <FormControlLabel 
                      value="yes" 
                      control={<Radio size={isMobile ? "medium" : "medium"} />} 
                      label="Yes" 
                    />
                    <FormControlLabel 
                      value="no" 
                      control={<Radio size={isMobile ? "medium" : "medium"} />} 
                      label="No" 
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </>
          )}
          
          {/* Organization Information for Non-Individual Investors */}
          {entityType !== 'individual' && (
            <>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
                  Organization Information
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Organization Name"
                  value={formData.organizationName}
                  onChange={(e) => handleFormDataChange('organizationName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Entity Type"
                  value={formData.entityType}
                  onChange={(e) => handleFormDataChange('entityType', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
  
  const renderAuthorizedRepresentatives = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          {entityType === 'individual' ? 'Document Upload' : 'Authorized Representatives'}
        </Typography>
        
        {entityType === 'individual' ? (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Please upload the required identification documents.
            </Typography>
            
            <Grid container spacing={{ xs: 2, md: 3 }}>
              {/* ID Upload Section */}
              <Grid item xs={12}>
                <Typography 
                  variant="h6" 
                  gutterBottom 
                  sx={{ 
                    mt: { xs: 2, md: 3 },
                    fontSize: { xs: '1.125rem', md: '1.25rem' }
                  }}
                >
                  Upload ID / Proof of Identification
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  For driver's license, both front and back sides are required.
                </Typography>
              </Grid>
              
              {/* Driver's License Front */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" gutterBottom>
                  Driver's License - Front Side
                </Typography>
                <Box
                  component="label"
                  sx={{
                    display: 'block',
                    border: '2px dashed #ccc',
                    borderRadius: 1,
                    p: 2,
                    textAlign: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: 'primary.main',
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    style={{ display: 'none' }}
                    onChange={(e) => handleFileUpload('license_front', e.target.files)}
                  />
                  <CloudUploadIcon sx={{ fontSize: 32, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    Upload front of license
                  </Typography>
                </Box>
                {uploadedFiles.license_front && uploadedFiles.license_front.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    {uploadedFiles.license_front.map(file => (
                      <Chip
                        key={file.id}
                        label={file.name}
                        onDelete={() => removeFile('license_front', file.id)}
                        size="small"
                        sx={{ mr: 1, mb: 1 }}
                      />
                    ))}
                  </Box>
                )}
              </Grid>
              
              {/* Driver's License Back */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" gutterBottom>
                  Driver's License - Back Side
                </Typography>
                <Box
                  component="label"
                  sx={{
                    display: 'block',
                    border: '2px dashed #ccc',
                    borderRadius: 1,
                    p: 2,
                    textAlign: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: 'primary.main',
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    style={{ display: 'none' }}
                    onChange={(e) => handleFileUpload('license_back', e.target.files)}
                  />
                  <CloudUploadIcon sx={{ fontSize: 32, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    Upload back of license
                  </Typography>
                </Box>
                {uploadedFiles.license_back && uploadedFiles.license_back.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    {uploadedFiles.license_back.map(file => (
                      <Chip
                        key={file.id}
                        label={file.name}
                        onDelete={() => removeFile('license_back', file.id)}
                        size="small"
                        sx={{ mr: 1, mb: 1 }}
                      />
                    ))}
                  </Box>
                )}
              </Grid>
              
              {/* Alternative ID Upload */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                  Alternative Identification (if not using driver's license)
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  You may upload passport, state ID, or other government-issued identification instead.
                </Typography>
                <Box
                  component="label"
                  sx={{
                    display: 'block',
                    border: '2px dashed #ccc',
                    borderRadius: 1,
                    p: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: 'primary.main',
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => handleFileUpload('alternative_id', e.target.files)}
                  />
                  <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    Upload alternative ID documents
                  </Typography>
                </Box>
                {uploadedFiles.alternative_id && uploadedFiles.alternative_id.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {uploadedFiles.alternative_id.map(file => (
                      <Chip
                        key={file.id}
                        label={file.name}
                        onDelete={() => removeFile('alternative_id', file.id)}
                        size="small"
                        sx={{ mr: 1, mb: 1 }}
                      />
                    ))}
                  </Box>
                )}
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Set forth below are the names of persons authorized by the Investor to 
              give and receive instructions between the Fund and the Investor, together 
              with their respective signatures and email addresses. Such persons are the 
              only persons so authorized until further notice to the Fund.
            </Typography>
            
            <Grid container spacing={{ xs: 2, md: 3 }}>
              {/* Authorized Signatory Information */}
              <Grid item xs={12}>
                <Typography 
                  variant="h6" 
                  gutterBottom 
                  sx={{ 
                    fontSize: { xs: '1.125rem', md: '1.25rem' }
                  }}
                >
                  Authorized Signatory Details
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Authorized Signatory Name"
                  value={formData.authorizedSignatoryName}
                  onChange={(e) => handleFormDataChange('authorizedSignatoryName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Signatory Title/Position"
                  value={formData.authorizedSignatoryTitle}
                  onChange={(e) => handleFormDataChange('authorizedSignatoryTitle', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Signatory Email"
                  type="email"
                  value={formData.authorizedSignatoryEmail}
                  onChange={(e) => handleFormDataChange('authorizedSignatoryEmail', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Signatory Phone"
                  value={formData.authorizedSignatoryPhone}
                  onChange={(e) => handleFormDataChange('authorizedSignatoryPhone', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              {/* Upload Authorized Signatory Documents */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                  Upload Authorized Signatory Documentation
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Please upload corporate resolutions, power of attorney, or other documents 
                  authorizing this person to act on behalf of the entity.
                </Typography>
                <Box
                  component="label"
                  sx={{
                    display: 'block',
                    border: '2px dashed #ccc',
                    borderRadius: 1,
                    p: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: 'primary.main',
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => handleFileUpload('authorized_signatory_docs', e.target.files)}
                  />
                  <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    Upload authorization documents
                  </Typography>
                </Box>
                {uploadedFiles.authorized_signatory_docs && uploadedFiles.authorized_signatory_docs.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {uploadedFiles.authorized_signatory_docs.map(file => (
                      <Chip
                        key={file.id}
                        label={file.name}
                        onDelete={() => removeFile('authorized_signatory_docs', file.id)}
                        size="small"
                        sx={{ mr: 1, mb: 1 }}
                      />
                    ))}
                  </Box>
                )}
              </Grid>
              
              {/* Additional Representatives */}
              <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mt: 2 }}>
                  Do you want to add additional authorized representatives?
                </Typography>
                <RadioGroup
                  value={formData.hasAdditionalRepresentatives}
                  onChange={(e) => handleFormDataChange('hasAdditionalRepresentatives', e.target.value)}
                  row
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </Grid>
              
              {formData.hasAdditionalRepresentatives === 'yes' && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom>
                    Additional Representatives List
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    Upload a document listing additional authorized representatives with their signatures.
                  </Typography>
                  <Box
                    component="label"
                    sx={{
                      display: 'block',
                      border: '2px dashed #ccc',
                      borderRadius: 1,
                      p: 3,
                      textAlign: 'center',
                      cursor: 'pointer',
                      '&:hover': {
                        borderColor: 'primary.main',
                        backgroundColor: 'action.hover'
                      }
                    }}
                  >
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      style={{ display: 'none' }}
                      onChange={(e) => handleFileUpload('additional_representatives', e.target.files)}
                    />
                    <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                      Upload additional representatives list
                    </Typography>
                  </Box>
                  {uploadedFiles.additional_representatives && uploadedFiles.additional_representatives.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      {uploadedFiles.additional_representatives.map(file => (
                        <Chip
                          key={file.id}
                          label={file.name}
                          onDelete={() => removeFile('additional_representatives', file.id)}
                          size="small"
                          sx={{ mr: 1, mb: 1 }}
                        />
                      ))}
                    </Box>
                  )}
                </Grid>
              )}
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  );
  
  const renderAddressInformation = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Address Information
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Driver's License Number"
              value={formData.driverLicenseNumber}
              onChange={(e) => handleFormDataChange('driverLicenseNumber', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Driver's License State"
              value={formData.driverLicenseState}
              onChange={(e) => handleFormDataChange('driverLicenseState', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Legal Resident State"
              value={formData.legalResidentState}
              onChange={(e) => handleFormDataChange('legalResidentState', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {formData.citizenshipStatus !== 'us-citizen' && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Passport Number"
                  value={formData.passportNumber}
                  onChange={(e) => handleFormDataChange('passportNumber', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Passport Issuing Country"
                  value={formData.passportCountry}
                  onChange={(e) => handleFormDataChange('passportCountry', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
        
        {/* Contact Information Section */}
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            mt: { xs: 3, md: 4 },
            fontSize: { xs: '1.125rem', md: '1.25rem' }
          }}
        >
          Contact Information
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Primary Phone Number"
              value={formData.primaryPhone}
              onChange={(e) => handleFormDataChange('primaryPhone', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Secondary Phone Number"
              value={formData.secondaryPhone}
              onChange={(e) => handleFormDataChange('secondaryPhone', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Primary Email Address"
              type="email"
              value={formData.primaryEmail}
              onChange={(e) => handleFormDataChange('primaryEmail', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Secondary Email Address"
              type="email"
              value={formData.secondaryEmail}
              onChange={(e) => handleFormDataChange('secondaryEmail', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Preferred Contact Method</InputLabel>
              <Select
                value={formData.preferredContactMethod}
                onChange={(e) => handleFormDataChange('preferredContactMethod', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="phone">Phone</MenuItem>
                <MenuItem value="mail">Mail</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>How did you hear about us?</InputLabel>
              <Select
                value={formData.howDidYouHear}
                onChange={(e) => handleFormDataChange('howDidYouHear', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="referral">Referral</MenuItem>
                <MenuItem value="website">Website</MenuItem>
                <MenuItem value="social-media">Social Media</MenuItem>
                <MenuItem value="advertisement">Advertisement</MenuItem>
                <MenuItem value="financial-advisor">Financial Advisor</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        
        {/* Age Verification */}
        <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mt: { xs: 2, md: 3 } }}>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <Typography 
                variant="subtitle1" 
                gutterBottom
                sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}
              >
                Are you over 18 years of age? *
              </Typography>
              <RadioGroup
                value={formData.overAge18}
                onChange={(e) => handleFormDataChange('overAge18', e.target.value)}
                row={!isMobile}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <FormControlLabel 
                  value="yes" 
                  control={<Radio size={isMobile ? "medium" : "medium"} />} 
                  label="Yes" 
                />
                <FormControlLabel 
                  value="no" 
                  control={<Radio size={isMobile ? "medium" : "medium"} />} 
                  label="No" 
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderTaxInformation = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Tax Information
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          Please provide tax information and select the appropriate tax form based on your status.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Tax Status Questions */}
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you exempt from US Federal Income Tax?
              </Typography>
              <RadioGroup
                value={formData.taxExemptFromUSFederalIncomeTax}
                onChange={(e) => handleFormDataChange('taxExemptFromUSFederalIncomeTax', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you a grantor trust or disregarded entity?
              </Typography>
              <RadioGroup
                value={formData.isGrantorTrustOrDisregardedEntity}
                onChange={(e) => handleFormDataChange('isGrantorTrustOrDisregardedEntity', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you exempt from US Tax?
              </Typography>
              <RadioGroup
                value={formData.exemptFromUSTax}
                onChange={(e) => handleFormDataChange('exemptFromUSTax', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you a grantor trust?
              </Typography>
              <RadioGroup
                value={formData.isGrantorTrust}
                onChange={(e) => handleFormDataChange('isGrantorTrust', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {/* Tax Form Selection */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
              Tax Form Selection
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Select Tax Form</InputLabel>
              <Select
                value={formData.selectedTaxDocument}
                onChange={(e) => handleFormDataChange('selectedTaxDocument', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="w9">W-9 Form (US Person)</MenuItem>
                <MenuItem value="w8ben">W-8BEN Form (Non-US Individual)</MenuItem>
                <MenuItem value="w8bene">W-8BEN-E Form (Non-US Entity)</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Additional Tax Information */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Tax Residency"
              value={formData.taxResidency}
              onChange={(e) => handleFormDataChange('taxResidency', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Foreign Tax ID Number"
              value={formData.foreignTaxIdNumber}
              onChange={(e) => handleFormDataChange('foreignTaxIdNumber', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Treaty Benefits"
              value={formData.treatyBenefits}
              onChange={(e) => handleFormDataChange('treatyBenefits', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Withholding Exemption"
              value={formData.withholdingExemption}
              onChange={(e) => handleFormDataChange('withholdingExemption', e.target.value)}
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {/* W-9 Form Fields (US Persons) */}
          {formData.selectedTaxDocument === 'w9' && (
            <>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
                  W-9 Form Information (US Persons)
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 Entity Name"
                  value={formData.w9EntityName}
                  onChange={(e) => handleFormDataChange('w9EntityName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 Business Name"
                  value={formData.w9BusinessName}
                  onChange={(e) => handleFormDataChange('w9BusinessName', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 Federal Tax Classification"
                  value={formData.w9FederalTaxClassification}
                  onChange={(e) => handleFormDataChange('w9FederalTaxClassification', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 LLC Classification"
                  value={formData.w9LlcClassification}
                  onChange={(e) => handleFormDataChange('w9LlcClassification', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 Ownership Interest"
                  value={formData.w9OwnershipInterest}
                  onChange={(e) => handleFormDataChange('w9OwnershipInterest', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 Legal Address"
                  value={formData.w9LegalAddress}
                  onChange={(e) => handleFormDataChange('w9LegalAddress', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="W-9 City"
                  value={formData.w9City}
                  onChange={(e) => handleFormDataChange('w9City', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="W-9 State"
                  value={formData.w9State}
                  onChange={(e) => handleFormDataChange('w9State', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="W-9 ZIP Code"
                  value={formData.w9ZipCode}
                  onChange={(e) => handleFormDataChange('w9ZipCode', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 Account Numbers"
                  value={formData.w9AccountNumbers}
                  onChange={(e) => handleFormDataChange('w9AccountNumbers', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-9 TIN Number"
                  value={formData.w9TinNumber}
                  onChange={(e) => handleFormDataChange('w9TinNumber', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
                  <InputLabel>W-9 TIN Type</InputLabel>
                  <Select
                    value={formData.w9TinType}
                    onChange={(e) => handleFormDataChange('w9TinType', e.target.value)}
                    sx={{
                      '& .MuiSelect-select': {
                        fontSize: { xs: '0.875rem', md: '1rem' }
                      }
                    }}
                  >
                    <MenuItem value="ssn">SSN</MenuItem>
                    <MenuItem value="ein">EIN</MenuItem>
                    <MenuItem value="itin">ITIN</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
                  <InputLabel>W-9 Backup Withholding</InputLabel>
                  <Select
                    value={formData.w9BackupWithholding}
                    onChange={(e) => handleFormDataChange('w9BackupWithholding', e.target.value)}
                    sx={{
                      '& .MuiSelect-select': {
                        fontSize: { xs: '0.875rem', md: '1rem' }
                      }
                    }}
                  >
                    <MenuItem value="exempt">Exempt</MenuItem>
                    <MenuItem value="not-exempt">Not Exempt</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="W-9 Certification"
                  value={formData.w9Certification}
                  onChange={(e) => handleFormDataChange('w9Certification', e.target.value)}
                  multiline
                  rows={3}
                  helperText="Please provide certification details"
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
          
          {/* W-8 Form Fields (Foreign Persons) */}
          {(formData.selectedTaxDocument === 'w8ben' || formData.selectedTaxDocument === 'w8bene') && (
            <>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
                  W-8 Form Information (Foreign Persons)
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-8 Entity Name"
                  value={formData.w8EntityName}
                  onChange={(e) => handleFormDataChange('w8EntityName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-8 Country of Incorporation"
                  value={formData.w8CountryOfIncorporation}
                  onChange={(e) => handleFormDataChange('w8CountryOfIncorporation', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-8 Taxpayer ID Number"
                  value={formData.w8TaxpayerIdNumber}
                  onChange={(e) => handleFormDataChange('w8TaxpayerIdNumber', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="W-8 Foreign Tax ID Type"
                  value={formData.w8ForeignTaxIdType}
                  onChange={(e) => handleFormDataChange('w8ForeignTaxIdType', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );

  const renderAMLInformation = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Anti Money Laundering Information
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          Please provide the required AML information and documentation for compliance purposes.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Source of Wealth"
              value={formData.sourceOfWealth}
              onChange={(e) => handleFormDataChange('sourceOfWealth', e.target.value)}
              multiline
              rows={3}
              helperText="Please describe the source of your wealth (e.g., salary, business income, investments, inheritance)"
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Wiring Bank Name"
              value={formData.wiringBankName}
              onChange={(e) => handleFormDataChange('wiringBankName', e.target.value)}
              helperText="Name of the bank from which you will wire funds"
              required
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Is Wiring Bank FATF Member?</InputLabel>
              <Select
                value={formData.isWiringBankFATF}
                onChange={(e) => handleFormDataChange('isWiringBankFATF', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
                <MenuItem value="not-sure">Not Sure</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Are you a customer of this bank?</InputLabel>
              <Select
                value={formData.isInvestorCustomerOfBank}
                onChange={(e) => handleFormDataChange('isInvestorCustomerOfBank', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Political Exposure Questions */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
              Political Exposure & Compliance
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you a Politically Exposed Person (PEP)?
              </Typography>
              <RadioGroup
                value={formData.isPoliticallyExposed}
                onChange={(e) => handleFormDataChange('isPoliticallyExposed', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.isPoliticallyExposed === 'yes' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Political Exposure Details"
                value={formData.politicalExposureDetails}
                onChange={(e) => handleFormDataChange('politicalExposureDetails', e.target.value)}
                multiline
                rows={3}
                helperText="Please provide details about your political position or relationship"
                required
                size={isMobile ? "medium" : "medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              />
            </Grid>
          )}
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Do you have any criminal convictions?
              </Typography>
              <RadioGroup
                value={formData.hasConvictions}
                onChange={(e) => handleFormDataChange('hasConvictions', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.hasConvictions === 'yes' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Conviction Details"
                value={formData.convictionDetails}
                onChange={(e) => handleFormDataChange('convictionDetails', e.target.value)}
                multiline
                rows={3}
                helperText="Please provide details about the conviction"
                required
                size={isMobile ? "medium" : "medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              />
            </Grid>
          )}
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you subject to any sanctions?
              </Typography>
              <RadioGroup
                value={formData.isSanctioned}
                onChange={(e) => handleFormDataChange('isSanctioned', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.isSanctioned === 'yes' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Sanction Details"
                value={formData.sanctionDetails}
                onChange={(e) => handleFormDataChange('sanctionDetails', e.target.value)}
                multiline
                rows={3}
                helperText="Please provide details about the sanctions"
                required
                size={isMobile ? "medium" : "medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );

    const renderAccreditedInvestorVerification = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Accredited Investor Verification
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          Please verify your accredited investor status and provide supporting documentation.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Accredited Investor Status */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Accredited Investor Status</InputLabel>
              <Select
                value={formData.accreditedInvestorStatus}
                onChange={(e) => handleFormDataChange('accreditedInvestorStatus', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="individual">Individual Accredited Investor</MenuItem>
                <MenuItem value="entity">Entity Accredited Investor</MenuItem>
                <MenuItem value="qualified-institutional-buyer">Qualified Institutional Buyer</MenuItem>
                <MenuItem value="not-accredited">Not Accredited</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Accredited Investor Type</InputLabel>
              <Select
                value={formData.accreditedInvestorType}
                onChange={(e) => handleFormDataChange('accreditedInvestorType', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="income">Income-based ($200k+ individual, $300k+ joint)</MenuItem>
                <MenuItem value="net-worth">Net worth-based ($1M+ excluding primary residence)</MenuItem>
                <MenuItem value="professional">Professional license holder</MenuItem>
                <MenuItem value="knowledgeable-employee">Knowledgeable employee</MenuItem>
                <MenuItem value="director-executive-officer">Director or executive officer</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Investment Amount Information */}
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Investment Amount"
              value={formData.investmentAmount}
              onChange={(e) => handleFormDataChange('investmentAmount', e.target.value)}
              type="number"
              helperText="Amount you plan to invest"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Minimum Investment"
              value={formData.minimumInvestment}
              onChange={(e) => handleFormDataChange('minimumInvestment', e.target.value)}
              type="number"
              helperText="Minimum amount you can invest"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Maximum Investment"
              value={formData.maximumInvestment}
              onChange={(e) => handleFormDataChange('maximumInvestment', e.target.value)}
              type="number"
              helperText="Maximum amount you can invest"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {/* Professional License Information */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Professional License Type</InputLabel>
              <Select
                value={formData.professionalLicenseType}
                onChange={(e) => handleFormDataChange('professionalLicenseType', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="series-7">Series 7</MenuItem>
                <MenuItem value="series-65">Series 65</MenuItem>
                <MenuItem value="series-66">Series 66</MenuItem>
                <MenuItem value="series-82">Series 82</MenuItem>
                <MenuItem value="cpa">CPA</MenuItem>
                <MenuItem value="attorney">Attorney</MenuItem>
                <MenuItem value="other">Other</MenuItem>
                <MenuItem value="none">None</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size={isMobile ? "medium" : "medium"}>
              <InputLabel>Accredited Verification Method</InputLabel>
              <Select
                value={formData.accreditedVerificationMethod}
                onChange={(e) => handleFormDataChange('accreditedVerificationMethod', e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              >
                <MenuItem value="self-certification">Self-Certification</MenuItem>
                <MenuItem value="third-party-verification">Third-Party Verification</MenuItem>
                <MenuItem value="documentation">Documentation Review</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Certification Fields */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
              Certifications
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Individual Net Worth Over $1 Million
              </Typography>
              <RadioGroup
                value={formData.individualNetWorthOver1Million}
                onChange={(e) => handleFormDataChange('individualNetWorthOver1Million', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Natural Person Qualified Institutional Buyer
              </Typography>
              <RadioGroup
                value={formData.naturalPersonQualifiedInstitutionalBuyer}
                onChange={(e) => handleFormDataChange('naturalPersonQualifiedInstitutionalBuyer', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Net Worth Certification"
              value={formData.netWorthCertification}
              onChange={(e) => handleFormDataChange('netWorthCertification', e.target.value)}
              multiline
              rows={2}
              helperText="Please provide net worth certification details"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Income Certification"
              value={formData.incomeCertification}
              onChange={(e) => handleFormDataChange('incomeCertification', e.target.value)}
              multiline
              rows={2}
              helperText="Please provide income certification details"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Professional Knowledge Certification"
              value={formData.professionalKnowledgeCertification}
              onChange={(e) => handleFormDataChange('professionalKnowledgeCertification', e.target.value)}
              multiline
              rows={2}
              helperText="Please provide professional knowledge certification"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Entity Assets Certification"
              value={formData.entityAssetsCertification}
              onChange={(e) => handleFormDataChange('entityAssetsCertification', e.target.value)}
              multiline
              rows={2}
              helperText="Please provide entity assets certification"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderElectronicCommunications = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Electronic Communications Consent
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          Please review and provide consent for electronic communications and delivery preferences.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Electronic Consent */}
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              The Investor hereby provides its informed consent to the electronic delivery of Account Communications by the Fund, the Investment Manager and/or the Administrator. If the Investor has not initialed this item, Account Communications will be delivered via facsimile or physical delivery (e.g., first class mail, overnight or express courier service or similar delivery method).
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Do you consent to electronic delivery of account communications?
              </Typography>
              <RadioGroup
                value={formData.consentToElectronicDelivery}
                onChange={(e) => handleFormDataChange('consentToElectronicDelivery', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Do you consent to electronic communications?
              </Typography>
              <RadioGroup
                value={formData.electronicConsent}
                onChange={(e) => handleFormDataChange('electronicConsent', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {/* Communication Preferences */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
              Communication Preferences
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Electronic Delivery
              </Typography>
              <RadioGroup
                value={formData.electronicDelivery}
                onChange={(e) => handleFormDataChange('electronicDelivery', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Email Updates
              </Typography>
              <RadioGroup
                value={formData.emailUpdates}
                onChange={(e) => handleFormDataChange('emailUpdates', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                SMS Notifications
              </Typography>
              <RadioGroup
                value={formData.smsNotifications}
                onChange={(e) => handleFormDataChange('smsNotifications', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {/* Additional Information */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1.125rem', md: '1.25rem' } }}>
              Additional Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Do you have an investment advisor?
              </Typography>
              <RadioGroup
                value={formData.hasInvestmentAdvisor}
                onChange={(e) => handleFormDataChange('hasInvestmentAdvisor', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.hasInvestmentAdvisor === 'yes' && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Investment Advisor Name"
                  value={formData.investmentAdvisorName}
                  onChange={(e) => handleFormDataChange('investmentAdvisorName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Investment Advisor Firm"
                  value={formData.investmentAdvisorFirm}
                  onChange={(e) => handleFormDataChange('investmentAdvisorFirm', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Investment Advisor Contact"
                  value={formData.investmentAdvisorContact}
                  onChange={(e) => handleFormDataChange('investmentAdvisorContact', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Do you have third-party access?
              </Typography>
              <RadioGroup
                value={formData.hasThirdPartyAccess}
                onChange={(e) => handleFormDataChange('hasThirdPartyAccess', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.hasThirdPartyAccess === 'yes' && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Third Party Name"
                  value={formData.thirdPartyName}
                  onChange={(e) => handleFormDataChange('thirdPartyName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Third Party Relationship"
                  value={formData.thirdPartyRelationship}
                  onChange={(e) => handleFormDataChange('thirdPartyRelationship', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Third Party Permissions"
                  value={formData.thirdPartyPermissions}
                  onChange={(e) => handleFormDataChange('thirdPartyPermissions', e.target.value)}
                  multiline
                  rows={3}
                  helperText="Please describe what permissions the third party should have"
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Special Instructions"
              value={formData.specialInstructions}
              onChange={(e) => handleFormDataChange('specialInstructions', e.target.value)}
              multiline
              rows={3}
              helperText="Any special instructions or additional information"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Additional Comments"
              value={formData.additionalComments}
              onChange={(e) => handleFormDataChange('additionalComments', e.target.value)}
              multiline
              rows={3}
              helperText="Any additional comments or notes"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const renderGeneralEligibility = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          General Eligibility
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          Please answer the following eligibility questions to determine your investment qualification.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {/* Placement Agent Information */}
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Were you referred by a placement agent?
              </Typography>
              <RadioGroup
                value={formData.wasReferredByPlacementAgent}
                onChange={(e) => handleFormDataChange('wasReferredByPlacementAgent', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.wasReferredByPlacementAgent === 'yes' && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Placement Agent Name"
                  value={formData.placementAgentName}
                  onChange={(e) => handleFormDataChange('placementAgentName', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Placement Agent Firm"
                  value={formData.placementAgentFirm}
                  onChange={(e) => handleFormDataChange('placementAgentFirm', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Placement Agent Compensation"
                  value={formData.placementAgentCompensation}
                  onChange={(e) => handleFormDataChange('placementAgentCompensation', e.target.value)}
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
          
          {/* Entity Type Questions */}
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you a government entity?
              </Typography>
              <RadioGroup
                value={formData.isGovernmentEntity}
                onChange={(e) => handleFormDataChange('isGovernmentEntity', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.isGovernmentEntity === 'yes' && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Government Entity Type"
                value={formData.governmentEntityType}
                onChange={(e) => handleFormDataChange('governmentEntityType', e.target.value)}
                required
                size={isMobile ? "medium" : "medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              />
            </Grid>
          )}
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you acting as an agent for a beneficial owner?
              </Typography>
              <RadioGroup
                value={formData.isActingAsAgentForBeneficialOwner}
                onChange={(e) => handleFormDataChange('isActingAsAgentForBeneficialOwner', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you an individual investing over $1 million?
              </Typography>
              <RadioGroup
                value={formData.isIndividualInvestingOver1Million}
                onChange={(e) => handleFormDataChange('isIndividualInvestingOver1Million', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {/* Investment Company Questions */}
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you a registered investment company?
              </Typography>
              <RadioGroup
                value={formData.isRegisteredInvestmentCompany}
                onChange={(e) => handleFormDataChange('isRegisteredInvestmentCompany', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.isRegisteredInvestmentCompany === 'yes' && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Investment Company Type"
                value={formData.investmentCompanyType}
                onChange={(e) => handleFormDataChange('investmentCompanyType', e.target.value)}
                required
                size={isMobile ? "medium" : "medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }
                }}
              />
            </Grid>
          )}
          
          {/* Beneficial Owner Information */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Number of Beneficial Owners"
              value={formData.numberOfBeneficialOwners}
              onChange={(e) => handleFormDataChange('numberOfBeneficialOwners', e.target.value)}
              type="number"
              size={isMobile ? "medium" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: { xs: '0.875rem', md: '1rem' }
                }
              }}
            />
          </Grid>
          
          {/* Benefit Plan Questions */}
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                Are you a benefit plan investor?
              </Typography>
              <RadioGroup
                value={formData.isBenefitPlanInvestor}
                onChange={(e) => handleFormDataChange('isBenefitPlanInvestor', e.target.value)}
                row={!isMobile}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          
          {formData.isBenefitPlanInvestor === 'yes' && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Benefit Plan Type"
                  value={formData.benefitPlanType}
                  onChange={(e) => handleFormDataChange('benefitPlanType', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Plan Assets"
                  value={formData.planAssets}
                  onChange={(e) => handleFormDataChange('planAssets', e.target.value)}
                  required
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControl component="fieldset">
                  <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                    Is this an ERISA plan?
                  </Typography>
                  <RadioGroup
                    value={formData.isERISA}
                    onChange={(e) => handleFormDataChange('isERISA', e.target.value)}
                    row={!isMobile}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Fiduciary Details"
                  value={formData.fiduciaryDetails}
                  onChange={(e) => handleFormDataChange('fiduciaryDetails', e.target.value)}
                  multiline
                  rows={3}
                  helperText="Please provide details about the fiduciary structure"
                  size={isMobile ? "medium" : "medium"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.875rem', md: '1rem' }
                    }
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );

  const renderWireInstructions = () => (
    <Card sx={{ mb: { xs: 2, md: 3 } }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography 
          variant="h5" 
          gutterBottom
          sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
        >
          Wire Instructions for Distributions
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: 3 }}
        >
          Please provide banking information for distributions.
        </Typography>
        
        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Bank Name"
              value={formData.bankName}
              onChange={(e) => handleFormDataChange('bankName', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Bank Address"
              value={formData.bankAddress}
              onChange={(e) => handleFormDataChange('bankAddress', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Routing Number"
              value={formData.routingNumber}
              onChange={(e) => handleFormDataChange('routingNumber', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Account Name"
              value={formData.accountName}
              onChange={(e) => handleFormDataChange('accountName', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
            />
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Account Number"
              value={formData.accountNumber}
              onChange={(e) => handleFormDataChange('accountNumber', e.target.value)}
              required
              size={isMobile ? "medium" : "medium"}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  // Render comprehensive review and submit section
  const renderReviewAndSubmit = () => {
    const formatValue = (value) => {
      if (value === null || value === undefined || value === '') return 'Not provided';
      if (typeof value === 'boolean') return value ? 'Yes' : 'No';
      if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : 'None';
      return value.toString();
    };

    const renderSectionSummary = (title, data, fields) => (
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
            {title}
          </Typography>
          <Grid container spacing={2}>
            {fields.map((field) => (
              <Grid item xs={12} sm={6} key={field.key}>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                    {field.label}:
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 400 }}>
                    {formatValue(data[field.key])}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    );

    return (
      <Box>
        <Card sx={{ mb: 3 }}>
          <CardContent sx={{ p: { xs: 2, md: 3 }, textAlign: 'center' }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
              Review and Submit
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Please carefully review all your information before submitting your application.
            </Typography>
            
            {/* Progress Summary */}
            <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8f9fa', borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 1, color: 'success.main' }}>
                Application Progress: 100% Complete
              </Typography>
              <LinearProgress 
                variant="determinate" 
                value={100} 
                sx={{ 
                  height: 8, 
                  borderRadius: 4,
                  backgroundColor: '#e9ecef',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: 'success.main'
                  }
                }} 
              />
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                All sections have been completed and are ready for review
              </Typography>
            </Box>
            
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>Important:</strong> Once submitted, you cannot edit your application. 
                Please ensure all information is accurate and complete.
              </Typography>
            </Alert>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
          </CardContent>
        </Card>

        {/* Basic Information */}
        {renderSectionSummary(
          'Basic Information',
          formData,
          [
            { key: 'investmentPurpose', label: 'Investment Purpose' },
            { key: 'howDidYouHear', label: 'How did you hear about us?' },
            { key: 'isTransferRelated', label: 'Is this transfer related?' },
            { key: 'purposeOfAccount', label: 'Purpose of Account' }
          ]
        )}

        {/* Personal Information */}
        {renderSectionSummary(
          'Personal Information',
          formData,
          [
            { key: 'firstName', label: 'First Name' },
            { key: 'middleName', label: 'Middle Name' },
            { key: 'lastName', label: 'Last Name' },
            { key: 'dateOfBirth', label: 'Date of Birth' },
            { key: 'socialSecurityNumber', label: 'Social Security Number' },
            { key: 'legalResidentState', label: 'Legal Resident State' },
            { key: 'overAge18', label: 'Over 18 Years Old' }
          ]
        )}

        {/* Contact Information */}
        {renderSectionSummary(
          'Contact Information',
          formData,
          [
            { key: 'primaryPhone', label: 'Primary Phone' },
            { key: 'primaryEmail', label: 'Primary Email' },
            { key: 'residenceAddress', label: 'Residence Address' },
            { key: 'city', label: 'City' },
            { key: 'state', label: 'State' },
            { key: 'zipCode', label: 'ZIP Code' },
            { key: 'country', label: 'Country' }
          ]
        )}

        {/* Mailing Address */}
        {formData.mailingAddressSame !== 'yes' && renderSectionSummary(
          'Mailing Address',
          formData,
          [
            { key: 'mailingAttention', label: 'Attention' },
            { key: 'mailingAddress', label: 'Mailing Address' },
            { key: 'mailingCity', label: 'City' },
            { key: 'mailingState', label: 'State' },
            { key: 'mailingZipCode', label: 'ZIP Code' },
            { key: 'mailingCountry', label: 'Country' }
          ]
        )}

        {/* Bank Information */}
        {renderSectionSummary(
          'Wire Instructions for Distributions',
          formData,
          [
            { key: 'bankName', label: 'Bank Name' },
            { key: 'bankAddress', label: 'Bank Address' },
            { key: 'routingNumber', label: 'Routing Number' },
            { key: 'accountName', label: 'Account Name' },
            { key: 'accountNumber', label: 'Account Number' }
          ]
        )}

        {/* AML Information */}
        {renderSectionSummary(
          'AML Information',
          formData,
          [
            { key: 'wiringBankName', label: 'Wiring Bank Name' },
            { key: 'isWiringBankFATF', label: 'Is Wiring Bank FATF Member?' },
            { key: 'isInvestorCustomerOfBank', label: 'Are you a customer of this bank?' },
            { key: 'sourceOfWealth', label: 'Source of Wealth' }
          ]
        )}

        {/* Tax Information */}
        {renderSectionSummary(
          'Tax Information',
          formData,
          [
            { key: 'taxExemptFromUSFederalIncomeTax', label: 'Exempt from US Federal Income Tax' },
            { key: 'isGrantorTrustOrDisregardedEntity', label: 'Grantor Trust or Disregarded Entity' },
            { key: 'exemptFromUSTax', label: 'Exempt from US Tax' },
            { key: 'isGrantorTrust', label: 'Is Grantor Trust' },
            { key: 'selectedTaxDocument', label: 'Selected Tax Document' },
            { key: 'taxResidency', label: 'Tax Residency' },
            { key: 'foreignTaxIdNumber', label: 'Foreign Tax ID Number' },
            { key: 'treatyBenefits', label: 'Treaty Benefits' },
            { key: 'withholdingExemption', label: 'Withholding Exemption' }
          ]
        )}

        {/* W-9 Information (US Persons) */}
        {(formData.w9EntityName || formData.w9TinNumber) && renderSectionSummary(
          'W-9 Form Information (US Persons)',
          formData,
          [
            { key: 'w9EntityName', label: 'Entity Name' },
            { key: 'w9BusinessName', label: 'Business Name' },
            { key: 'w9FederalTaxClassification', label: 'Federal Tax Classification' },
            { key: 'w9LlcClassification', label: 'LLC Classification' },
            { key: 'w9OwnershipInterest', label: 'Ownership Interest' },
            { key: 'w9LegalAddress', label: 'Legal Address' },
            { key: 'w9City', label: 'City' },
            { key: 'w9State', label: 'State' },
            { key: 'w9ZipCode', label: 'ZIP Code' },
            { key: 'w9Country', label: 'Country' },
            { key: 'w9AccountNumbers', label: 'Account Numbers' },
            { key: 'w9TinNumber', label: 'TIN Number' },
            { key: 'w9TinType', label: 'TIN Type' },
            { key: 'w9BackupWithholding', label: 'Backup Withholding' },
            { key: 'w9Certification', label: 'Certification' }
          ]
        )}

        {/* W-8 Information (Foreign Persons) */}
        {(formData.w8EntityName || formData.w8TaxpayerIdNumber) && renderSectionSummary(
          'W-8 Form Information (Foreign Persons)',
          formData,
          [
            { key: 'w8EntityName', label: 'Entity Name' },
            { key: 'w8CountryOfIncorporation', label: 'Country of Incorporation' },
            { key: 'w8TaxpayerIdNumber', label: 'Taxpayer ID Number' },
            { key: 'w8ForeignTaxIdType', label: 'Foreign Tax ID Type' }
          ]
        )}

        {/* General Eligibility */}
        {renderSectionSummary(
          'General Eligibility',
          formData,
          [
            { key: 'wasReferredByPlacementAgent', label: 'Referred by Placement Agent' },
            { key: 'isGovernmentEntity', label: 'Government Entity' },
            { key: 'isActingAsAgentForBeneficialOwner', label: 'Acting as Agent for Beneficial Owner' },
            { key: 'isIndividualInvestingOver1Million', label: 'Individual Investing Over $1M' },
            { key: 'isPoliticallyExposed', label: 'Politically Exposed Person' },
            { key: 'politicalExposureDetails', label: 'Political Exposure Details' },
            { key: 'hasConvictions', label: 'Has Convictions' },
            { key: 'convictionDetails', label: 'Conviction Details' },
            { key: 'isSanctioned', label: 'Is Sanctioned' },
            { key: 'sanctionDetails', label: 'Sanction Details' }
          ]
        )}

        {/* Accredited Investor Verification */}
        {renderSectionSummary(
          'Accredited Investor Verification',
          formData,
          [
            { key: 'accreditedInvestorStatus', label: 'Accredited Investor Status' },
            { key: 'individualNetWorthOver1Million', label: 'Individual Net Worth Over $1M' },
            { key: 'naturalPersonQualifiedInstitutionalBuyer', label: 'Natural Person QIB' }
          ]
        )}

        {/* Authorized Representatives */}
        {formData.hasAuthorizedRepresentative === 'yes' && renderSectionSummary(
          'Authorized Representatives',
          formData,
          [
            { key: 'authorizedSignatoryName', label: 'Authorized Signatory Name' },
            { key: 'authorizedSignatoryTitle', label: 'Authorized Signatory Title' },
            { key: 'authorizedSignatoryEmail', label: 'Authorized Signatory Email' },
            { key: 'authorizedSignatoryPhone', label: 'Authorized Signatory Phone' },
            { key: 'hasAdditionalRepresentatives', label: 'Has Additional Representatives' }
          ]
        )}

        {/* Electronic Communications */}
        {renderSectionSummary(
          'Electronic Communications',
          formData,
          [
            { key: 'consentToElectronicDelivery', label: 'Consent to Electronic Delivery' }
          ]
        )}

        {/* Uploaded Documents Summary */}
        {Object.keys(uploadedFiles).some(category => uploadedFiles[category]?.length > 0) && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                Uploaded Documents
              </Typography>
              <Grid container spacing={2}>
                {Object.entries(uploadedFiles).map(([category, files]) => {
                  if (!files || files.length === 0) return null;
                  return (
                    <Grid item xs={12} sm={6} key={category}>
                      <Box sx={{ mb: 1 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                          {category.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 400 }}>
                          {files.length} file(s) uploaded
                        </Typography>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </CardContent>
          </Card>
        )}

        {/* Final Confirmation */}
        <Card sx={{ mb: 3, backgroundColor: '#f8f9fa', border: '2px solid #e9ecef' }}>
          <CardContent sx={{ p: { xs: 2, md: 3 }, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 2, color: 'success.main', fontWeight: 600 }}>
              Final Confirmation
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              By clicking "Submit Application" below, you confirm that:
            </Typography>
            <List dense>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary="All information provided is accurate and complete" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary="You have reviewed all sections of the application" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary="You understand this application will be reviewed by our compliance team" />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary="You agree to the terms and conditions of the investment" />
              </ListItem>
            </List>
          </CardContent>
        </Card>

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4, mb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setStepIndex(stepIndex - 1)}
            startIcon={<ArrowBackIcon />}
            sx={{ minWidth: 150 }}
          >
            Back to Edit
          </Button>
          <Button
            variant="contained"
            color="success"
            size="large"
            onClick={async () => {
              setSubmitting(true);
              const ok = await saveFormData();
              setSubmitting(false);
              if (ok) {
                setError('');
                alert('Application submitted successfully!');
              }
            }}
            disabled={submitting}
            sx={{ minWidth: 200, py: 1.5, fontSize: '1.1rem', fontWeight: 600 }}
          >
            {submitting ? <CircularProgress size={24} color="inherit" /> : 'Submit Application'}
          </Button>
        </Box>
      </Box>
    );
  };

  // Main render function with sections
  const renderSection = () => {
    // If stepIndex is 0, we're in entity selection
    if (stepIndex === 0) {
      return renderEntitySelection();
    }
    
    const currentStep = stepIndex - 1; // Adjust for entity selection step
    const sections = [
      'basic-questions',
      'investor-profile', 
      'aml-information',
      'tax-information',
      'general-eligibility',
      'accredited-investor-verification',
      'wire-instructions',
      'electronic-communications',
      'authorized-representatives',
      'submit'
    ];
    
    const currentSectionId = sections[currentStep] || 'basic-questions';
    
    if (currentSectionId === 'submit') {
      return renderReviewAndSubmit();
    }
    
    switch (currentSectionId) {
      case 'basic-questions':
        return renderBasicQuestions();
      case 'investor-profile':
        return renderInvestorProfile();
      case 'authorized-representatives':
        return renderAuthorizedRepresentatives();
      case 'tax-information':
        return renderTaxInformation();
      case 'aml-information':
        return renderAMLInformation();
      case 'accredited-investor-verification':
        return renderAccreditedInvestorVerification();
      case 'wire-instructions':
        return renderWireInstructions();
      case 'electronic-communications':
        return renderElectronicCommunications();
      case 'general-eligibility':
        return renderGeneralEligibility();
      default:
        return renderBasicQuestions();
    }
  };

  // Render function for entity selection step
  const renderEntitySelection = () => (
    <Box sx={{ 
      maxWidth: { xs: '100%', sm: 480 }, 
      mx: 'auto', 
      mt: { xs: 2, sm: 4, md: 8 }, 
      p: { xs: 2, sm: 3, md: 4 }, 
      bgcolor: 'white', 
      borderRadius: 2, 
      boxShadow: 2 
    }}>
      <Typography 
        variant={isMobile ? "h5" : "h4"} 
        sx={{ 
          mb: { xs: 3, md: 4 }, 
          fontWeight: 700,
          textAlign: { xs: 'center', sm: 'left' }
        }}
      >
        Who are you making this investment for?
      </Typography>
      
      <RadioGroup
        value={formData.investmentPurpose}
        onChange={e => handleFormDataChange('investmentPurpose', e.target.value)}
      >
        <FormControlLabel 
          value="individual" 
          control={<Radio size={isMobile ? "medium" : "large"} />} 
          label={
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: { xs: 1, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' },
              textAlign: { xs: 'center', sm: 'left' }
            }}>
              <PersonIcon fontSize={isMobile ? "medium" : "large"} />
              <Typography variant={isMobile ? "body1" : "body1"}>
                I'm investing for myself
              </Typography>
            </Box>
          } 
          sx={{ 
            mb: 2, 
            p: { xs: 1.5, sm: 2 }, 
            border: '1px solid #eee', 
            borderRadius: 2,
            width: '100%'
          }} 
        />
        
        <FormControlLabel 
          value="investment-team" 
          control={<Radio size={isMobile ? "medium" : "large"} />} 
          label={
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: { xs: 1, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' },
              textAlign: { xs: 'center', sm: 'left' }
            }}>
              <GroupIcon fontSize={isMobile ? "medium" : "large"} />
              <Typography variant={isMobile ? "body1" : "body1"}>
                I'm part of an investment team
              </Typography>
            </Box>
          } 
          sx={{ 
            mb: 2, 
            p: { xs: 1.5, sm: 2 }, 
            border: '1px solid #eee', 
            borderRadius: 2,
            width: '100%'
          }} 
        />
        
        <FormControlLabel 
          value="advisor" 
          control={<Radio size={isMobile ? "medium" : "large"} />} 
          label={
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: { xs: 1, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' },
              textAlign: { xs: 'center', sm: 'left' }
            }}>
              <BusinessCenterIcon fontSize={isMobile ? "medium" : "large"} />
              <Typography variant={isMobile ? "body1" : "body1"}>
                I'm an advisor operating for my investor
              </Typography>
            </Box>
          } 
          sx={{ 
            mb: 2, 
            p: { xs: 1.5, sm: 2 }, 
            border: '1px solid #eee', 
            borderRadius: 2,
            width: '100%'
          }} 
        />
      </RadioGroup>
      
      <Button 
        variant="contained"
        color="primary"
        fullWidth
        sx={{ 
          mt: { xs: 3, md: 4 }, 
          py: { xs: 1.5, md: 1.5 }, 
          fontSize: { xs: '1rem', md: '1.1rem' }, 
          fontWeight: 600 
        }}
        disabled={!formData.investmentPurpose || submitting}
        onClick={async () => {
          setSubmitting(true);
          setError('');
          
          try {
            const dataToSave = {
              email: approvedEmail,
              organization_name: applicantName || 'Individual Investor',
              entity_type: formData.investmentPurpose === 'individual' ? 'individual' : 'organization',
              current_step: 0,
              current_section: 'entity-selection',
              form_data: {
                ...formData,
                applicant_name: applicantName,
                investment_type: formData.investmentPurpose,
                organization_name: applicantName,
                entity_type: formData.investmentPurpose === 'individual' ? 'individual' : 'organization'
              },
              progress: calculateSectionProgress(),
              last_updated: new Date().toISOString()
            };
            
            const response = await apiClient.post('/investor/save-subscription', dataToSave);
            
            if (response.data.status === 'success') {
              console.log('✅ Entity selection saved, proceeding to next step');
              setStepIndex(1);
            } else {
              throw new Error(response.data.message || 'Failed to save selection');
            }
          } catch (error) {
            console.error('❌ Error saving entity selection:', error);
            setError(error.response?.data?.message || 'Failed to save selection. Please try again.');
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {submitting ? <CircularProgress size={24} color="inherit" /> : 'Continue'}
      </Button>
    </Box>
  );

  // Responsive progress indicator
  const renderProgressIndicator = () => {
    if (isMobile) {
      return (
        <Box 
          className="mobile-progress" 
          sx={{ 
            mb: 3,
            position: 'sticky',
            top: 0,
            zIndex: 100,
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            px: { xs: 2, sm: 3 },
            py: 2
          }}
        >
          {/* Mobile Progress Bar */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mb: 2,
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1, sm: 2 }
          }}>
            <Typography 
              variant="body2" 
              sx={{ 
                fontSize: { xs: '0.875rem', sm: '1rem' },
                fontWeight: 500,
                textAlign: { xs: 'center', sm: 'left' }
              }}
            >
              Step {stepIndex + 1} of {sectionOrder.length}
            </Typography>
            <LinearProgress 
              variant="determinate" 
              value={((stepIndex + 1) / sectionOrder.length) * 100} 
              sx={{ 
                flexGrow: 1, 
                height: { xs: 8, sm: 10 }, 
                borderRadius: { xs: 4, sm: 5 },
                minWidth: { xs: '100%', sm: 200 },
                '& .MuiLinearProgress-bar': {
                  borderRadius: { xs: 4, sm: 5 }
                }
              }}
            />
          </Box>
          
          {/* Mobile Step Title */}
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600, 
              mb: 2,
              fontSize: { xs: '1.125rem', sm: '1.25rem' },
              textAlign: { xs: 'center', sm: 'left' },
              color: 'primary.main'
            }}
          >
            {stepIndex === 0 ? 'Entity Selection' : 
             sectionOrder[stepIndex - 1]?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
          </Typography>
          
          {/* Mobile Progress Button */}
          <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-start' } }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<ListIcon />}
              onClick={() => setShowProgressDialog(true)}
              sx={{ 
                fontSize: { xs: '0.875rem', sm: '1rem' },
                minHeight: { xs: 40, sm: 44 },
                px: { xs: 2, sm: 3 }
              }}
            >
              View All Steps
            </Button>
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={{ 
        mb: 4,
        display: { xs: 'none', md: 'block' }
      }}>
        <Stepper 
          activeStep={stepIndex} 
          alternativeLabel
          sx={{
            '& .MuiStepLabel-root': {
              '& .MuiStepLabel-label': {
                fontSize: { lg: '1rem', xl: '1.125rem' }
              }
            }
          }}
        >
          {sectionOrder.map((section, idx) => (
            <Step key={section} completed={stepIndex > idx}>
              <StepLabel>
                {section.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    );
  };

  // Progress Dialog for Mobile
  const renderProgressDialog = () => (
    <Dialog 
      open={showProgressDialog} 
      onClose={() => setShowProgressDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Registration Progress</DialogTitle>
      <DialogContent>
        <List>
          {sectionOrder.map((section, idx) => (
            <ListItem key={section} sx={{ 
              bgcolor: stepIndex === idx ? 'primary.light' : 'transparent',
              borderRadius: 1,
              mb: 1
            }}>
              <ListItemIcon>
                {stepIndex > idx ? (
                  <CheckCircleIcon color="success" />
                ) : stepIndex === idx ? (
                  <CircularProgress size={20} />
                ) : (
                  <RadioButtonUncheckedIcon color="disabled" />
                )}
              </ListItemIcon>
              <ListItemText 
                primary={section.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                secondary={stepIndex > idx ? 'Completed' : stepIndex === idx ? 'In Progress' : 'Pending'}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowProgressDialog(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );

  // Responsive navigation buttons
  const renderNavigationButtons = () => {
    if (stepIndex === 0 || stepIndex >= sectionOrder.length - 1) return null;

    return (
      <Box 
        className="mobile-button-container"
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          mt: { xs: 2, sm: 3 },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 3 },
          position: { xs: 'sticky', sm: 'static' },
          bottom: { xs: 0, sm: 'auto' },
          bgcolor: { xs: 'background.paper', sm: 'transparent' },
          borderTop: { xs: '1px solid', sm: 'none' },
          borderColor: { xs: 'divider', sm: 'transparent' },
          zIndex: { xs: 99, sm: 'auto' },
          p: { xs: 2, sm: 0 },
          boxShadow: { xs: '0 -2px 8px rgba(0,0,0,0.1)', sm: 'none' }
        }}
      >
        <Button 
          variant="outlined" 
          onClick={() => setStepIndex(stepIndex - 1)} 
          disabled={stepIndex === 0}
          fullWidth={isMobile}
          startIcon={<ArrowBackIcon />}
          sx={{ 
            minHeight: { xs: 48, sm: 44 },
            fontSize: { xs: '1rem', sm: '0.875rem' },
            py: { xs: 1.5, sm: 1 }
          }}
        >
          Back
        </Button>
        <Button 
          variant="contained" 
          onClick={saveCurrentStepAndContinue}
          disabled={submitting}
          fullWidth={isMobile}
          endIcon={<ArrowForwardIcon />}
          sx={{ 
            minHeight: { xs: 48, sm: 44 },
            fontSize: { xs: '1rem', sm: '0.875rem' },
            py: { xs: 1.5, sm: 1 }
          }}
        >
          {submitting ? <CircularProgress size={24} color="inherit" /> : 'Continue'}
        </Button>
      </Box>
    );
  };

  // Mobile Speed Dial for quick navigation
  const renderSpeedDial = () => {
    if (!isMobile) return null;

    const actions = [
      { icon: <KeyboardArrowUpIcon />, name: 'Previous Step', action: () => stepIndex > 0 && setStepIndex(stepIndex - 1) },
      { icon: <ListIcon />, name: 'View Progress', action: () => setShowProgressDialog(true) },
      { icon: <KeyboardArrowDownIcon />, name: 'Next Step', action: () => stepIndex < sectionOrder.length - 1 && saveCurrentStepAndContinue() },
    ];

    return (
      <SpeedDial
        ariaLabel="Navigation"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.action}
          />
        ))}
      </SpeedDial>
    );
  };

  // Show loading state
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Show completion status if user has already submitted
  if (isSubmissionCompleted) {
    return (
      <Box 
        sx={{ 
          maxWidth: { xs: '100%', sm: 600 }, 
          mx: 'auto', 
          p: { xs: 2, sm: 3 },
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          bgcolor: 'background.default'
        }}
      >
        <Card sx={{ p: { xs: 3, sm: 4 }, textAlign: 'center' }}>
          <CheckCircleIcon 
            sx={{ 
              fontSize: { xs: 60, sm: 80 }, 
              color: 'success.main', 
              mb: 2 
            }} 
          />
          <Typography 
            variant="h4" 
            gutterBottom
            sx={{ 
              color: 'text.primary',
              fontWeight: 600,
              fontSize: { xs: '1.5rem', sm: '2rem' }
            }}
          >
            Application Submitted Successfully!
          </Typography>
          <Typography 
            variant="body1" 
            color="text.secondary" 
            paragraph
            sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }}
          >
            Thank you for submitting your subscription application. We have received your 
            information and will review it shortly.
          </Typography>
          {submissionDate && (
            <Typography variant="body2" color="text.secondary" paragraph>
              Submitted on: {new Date(submissionDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </Typography>
          )}
          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6" gutterBottom>
              What happens next?
            </Typography>
            <List sx={{ textAlign: 'left', maxWidth: 400, mx: 'auto' }}>
              <ListItem>
                <ListItemIcon>
                  <EmailIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Email Confirmation"
                  secondary="You'll receive a confirmation email within 24 hours"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <VerifiedUserIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Document Review"
                  secondary="Our team will review your submitted documents"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <BusinessIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Account Setup"
                  secondary="Once approved, we'll set up your investment account"
                />
              </ListItem>
            </List>
          </Box>
          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
            <Typography variant="body2" color="text.secondary">
              If you have any questions, please contact our support team.
            </Typography>
            <Button 
              variant="outlined" 
              sx={{ mt: 2 }}
              onClick={() => window.location.href = 'mailto:support@blockfirstcapital.com'}
            >
              Contact Support
            </Button>
          </Box>
        </Card>
      </Box>
    );
  }

  return (
    <Box 
      className="mobile-form-container"
      sx={{ 
        maxWidth: { xs: '100%', sm: 600, md: 800, lg: 1200 }, 
        mx: 'auto', 
        p: { xs: 1, sm: 2, md: 3 },
        minHeight: '100vh',
        pb: { xs: 8, md: 3 }, // Extra padding bottom for mobile to account for speed dial
        bgcolor: 'background.default'
      }}
    >
      {renderProgressIndicator()}
      <Box sx={{ 
        px: { xs: 1, sm: 0 },
        pb: { xs: 8, sm: 0 } // Space for mobile navigation
      }}>
        {renderSection()}
        {renderNavigationButtons()}
      </Box>
      {renderProgressDialog()}
      {renderSpeedDial()}
    </Box>
  );
};

export default SubscriptionForm; 